export default {
  brand: {
    primary: '#444444',
    secondary: '#EC8117',
    tertiary: '#117DAC',
    quaternary: '#D3D3D3',
  },
};
